import { useContext, useMemo } from "react";
import { RightsHolderBandViewModel } from "../../../generated/data-contracts";
import { IAxiosError, TableUtils } from "../../../utils";
import { AvisLoader } from "../../shared/components";
import { AvisSection } from "../../shared/components/form";
import { AvisSimpleTable, IColumnConfig } from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";

interface IBandsGridProps {
  initGridData?: RightsHolderBandViewModel[];
  isGridLoading: boolean;
  error?: IAxiosError;
}

export function BandsGrid(props: Readonly<IBandsGridProps>) {
  const { initGridData, error, isGridLoading } = props;
  const { res } = useContext(AvisContext);

  const renderGrid = useMemo(() => {
    if (!initGridData) return <AvisLoader inline />;

    const columnMetadata: IColumnConfig[] = [
      TableUtils.columnConfigString<RightsHolderBandViewModel>(
        "name",
        res("authors_BandName_GridColGroupName"),
      ),
    ];

    return (
      <ErrorLoadingDataHoc error={error} loading={isGridLoading}>
        <AvisSimpleTable<RightsHolderBandViewModel>
          columnMetadata={columnMetadata}
          data={initGridData}
          mobileViewDisabled
        />
      </ErrorLoadingDataHoc>
    );
  }, [error, res, initGridData, isGridLoading]);

  return (
    <AvisSection title={res("authors_BandName_GroupGridTitle")}>
      {renderGrid}
    </AvisSection>
  );
}
